export enum FieldNames {
  Email = 'email',
  Phone = 'phone',
  Name = 'name',
  Address = 'address',
  FirstName = 'firstName',
  LastName = 'lastName',
}

